import {BrowserRouter, Route, Routes} from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import './App.css';

import Login from './components/Login';
import CustomDashboard from './components/customDashboard';
import Logout from './components/Logout';
import FarmersTable from "./components/farmers/FarmersTable";
import Calender from "./components/calender";
import MultiplicatorsTable from "./components/multiplicators/MultiplicatorsTable";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route>
                    <Route path="/" element={<Login />} />
                    {/*<Route path="/login" element={<Login />} />*/}

                    {/*<Route path="/notizen" element={<MainLayout />}>
                        <Route index element={<Start />} />
                    </Route>*/}

                    <Route path="/dashboard" element={<MainLayout />}>
                        <Route index element={<CustomDashboard />} />
                    </Route>

                    <Route path="/farmers" element={<MainLayout />}>
                        <Route index element={<FarmersTable />} />
                    </Route>

                    <Route path="/multiplikatoren" element={<MainLayout />}>
                        <Route index element={<MultiplicatorsTable />} />
                    </Route>

                    <Route path="/calender" element={<MainLayout />}>
                        <Route index element={<Calender />} />
                    </Route>

                    <Route path="/logout" element={<Logout />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
